import React from 'react';

interface CardTopSvgProps {
  width?: number;
  height?: number;
}

const CardTopSvg: React.FC<CardTopSvgProps> = ({ width = 380, height = 269 }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 380 269" 
      fill="none"
      style={{ display: 'block', width: '100%', height: 'auto' }}
    >
      <path 
        d="M0 20C0 8.9543 8.95431 0 20 0H360C371.046 0 380 8.9543 380 20V100.781L370.528 112.016C369.015 113.811 368.954 116.417 370.382 118.281L380 130.829V269H0V130.829L9.61775 118.281C11.046 116.417 10.9854 113.811 9.47199 112.016L0 100.781V20Z" 
        fill="white"
      />
    </svg>
  );
};

export default CardTopSvg;